import type { DashboardDto } from "@stryker/core/types/dashboard";

import BarChart from "./charts/BarChart";
import { sortByFromBiggestKits } from "./utils";

type KitsCountProps = {
  graphsData?: DashboardDto["kits"];
};
export default function KitsCount({ graphsData }: KitsCountProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <BarChart
        data={graphsData?.byPlantName?.toSorted(sortByFromBiggestKits) ?? []}
        dataKey="plantName"
        barDataKey="kits"
        barName="by plant"
        color="orange"
        title="Kits count by plant"
      />
      <BarChart
        data={
          graphsData?.byBranch
            ?.map(({ kits, branch }) => {
              return {
                kits,
                label: branch ?? "N/A",
              };
            })
            .toSorted(sortByFromBiggestKits) ?? []
        }
        dataKey="label"
        barDataKey="kits"
        barName="by branch"
        color="blue"
        title="Kits count by branch"
      />
      <BarChart
        data={graphsData?.byPerson?.toSorted(sortByFromBiggestKits) ?? []}
        dataKey="person"
        barDataKey="kits"
        hideX
        barName="by person"
        color="purple"
        title="Kits count by person"
      />
      <BarChart
        data={graphsData?.byKitSize.toSorted(sortByFromBiggestKits) ?? []}
        dataKey="kitSize"
        barDataKey="kits"
        hideX
        barName="by kit size"
        color="purple"
        title="Kits count by kits size"
      />
      <BarChart
        data={graphsData?.byRepairSystem?.toSorted(sortByFromBiggestKits) ?? []}
        dataKey="repairSystem"
        barDataKey="kits"
        barName="by repair system"
        hideX
        color="violet"
        title="Kits count by repair system"
      />
    </div>
  );
}
